import { Textarea } from "@ferrivia/ui";
import { FREE_TEXT_MAX } from "@ferrivia/api-contract";
import { useTranslation } from "@ferrivia/i18n";
import { focusWithoutPan } from "../../onboarding/focusWithoutPan";
import f from "./fieldBox.module.css";
import s from "./TextQuestion.module.css";

export interface TextQuestionProps {
  labelledBy: string;
  value: string;
  onChange: (value: string) => void;
  errorText?: string;
  /** The contract's `control: "long_text"` hint: starts tall rather than
      as a one-line field that grows. */
  long?: boolean;
}

/** Enforced here and again by `saveAnswers` server-side (the plan's
    "a client-only cap on Art. 9 free text is not a cap") -- `maxLength`
    stops a client typing past the limit, the server stops anyone who
    bypasses this component entirely. */
export function TextQuestion({ labelledBy, value, onChange, errorText, long }: TextQuestionProps) {
  const { t } = useTranslation("client");
  return (
    <div className={s.root}>
      <Textarea
        className={f.box}
        aria-labelledby={labelledBy}
        placeholder={t("questionnaire.textPlaceholder", "Kirjoita vastauksesi")}
        value={value}
        maxLength={FREE_TEXT_MAX}
        {...(long ? { rows: 6, maxHeight: 480 } : {})}
        onMouseDown={focusWithoutPan}
        aria-invalid={Boolean(errorText)}
        onChange={(event) => onChange(event.target.value)}
      />
      {errorText ? (
        <span role="alert" className={s.error}>
          {errorText}
        </span>
      ) : null}
    </div>
  );
}
